var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accordion-trigger",on:{"click":_vm.trigger}},[_c('h2',{staticClass:"heading-2 text-underline m-0"},[_vm._t("default")],2),_c('NbIcon',{attrs:{"icon":"chevron-down","size":16,"attributes":{
      style: `${_vm.context.isOpen ? 'transform: rotate(180deg)' : ''}`,
    }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }